module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "structure",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('span', {
    staticClass: "bold2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('span', {
    staticClass: "bold2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body-text-center"
  }, [_c('span', {
    staticClass: "bold4"
  }, [_vm._v("Dedicated to the elders in my")]), _c('span', {
    staticClass: "bold4"
  }), _c('span', {
    staticClass: "bold4"
  }, [_vm._v("tribe:")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-center"
  }, [_vm._v("Hilda & Myron"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("Leota & Gary"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("Joseph & Mavis"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("and of course,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("I would be nothing without my loves:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("Torino, Golden, & Sage")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb40f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_003.vue
// module id = 69
// module chunks = 0